import {
  GET_EVALUATION_TYPES,
  GET_EVALUATION_TYPES_FAIL,
  GET_EVALUATION_TYPES_SUCCESS,
  ADD_NEW_EVALUATION_TYPE,
  ADD_EVALUATION_TYPE_SUCCESS,
  ADD_EVALUATION_TYPE_FAIL,
  UPDATE_EVALUATION_TYPE,
  UPDATE_EVALUATION_TYPE_SUCCESS,
  UPDATE_EVALUATION_TYPE_FAIL,
  DELETE_EVALUATION_TYPE,
  DELETE_EVALUATION_TYPE_SUCCESS,
  DELETE_EVALUATION_TYPE_FAIL,


  
} from "./actionTypes";

export const getEvaluationTypes = () => ({
  type: GET_EVALUATION_TYPES,
})

export const getEvaluationTypesSuccess = evaluationTypes => ({
  type: GET_EVALUATION_TYPES_SUCCESS,
  payload: evaluationTypes,
})

export const getEvaluationTypesFail = error => ({
  type: GET_EVALUATION_TYPES_FAIL,
  payload: error,
})

export const addNewEvaluationType = data => ({
  type: ADD_NEW_EVALUATION_TYPE,
  payload: data,
})

export const addEvaluationTypeSuccess = evaluationType => ({
  type: ADD_EVALUATION_TYPE_SUCCESS,
  payload: evaluationType,
})

export const addEvaluationTypeFail = error => ({
  type: ADD_EVALUATION_TYPE_FAIL,
  payload: error,
})

export const updateEvaluationType = evaluationType => ({
  type: UPDATE_EVALUATION_TYPE,
  payload: evaluationType,
})

export const updateEvaluationTypeSuccess = evaluationType => ({
  type: UPDATE_EVALUATION_TYPE_SUCCESS,
  payload: evaluationType,
})

export const updateEvaluationTypeFail = error => ({
  type: UPDATE_EVALUATION_TYPE_FAIL,
  payload: error,
})

export const deleteEvaluationType = data => ({
  type: DELETE_EVALUATION_TYPE,
  payload: data,
})

export const deleteEvaluationTypeSuccess = data => ({
  type: DELETE_EVALUATION_TYPE_SUCCESS,
  payload: data,
})

export const deleteEvaluationTypeFail = error => ({
  type: DELETE_EVALUATION_TYPE_FAIL,
  payload: error,
})

export const resetEvaluationTypeLastActionSuccess = () => ({
    type: "RESET_LAST_ACTION_SUCCESS"
});


